import { 
  gql, 
  useQuery 
} from "@apollo/client";
import { 
  CustomersOverviewAdminQueryQuery, 
  QueryCustomersOverviewAdminArgs 
} from "../../../../../schemaTypes";

export const customersOverviewAdminQuery = gql`
  query CustomersOverviewAdminQuery(
    $duration: String!
  ) {
    customersOverviewAdmin(
      duration: $duration 
    ) {
        registeredCustomers
        activeCustomers
        inActiveCustomers
        totalCurrentBalance
        totalSpend
        totalAmbassador
    }
  }
`;

export interface WithCustomersOverviewAdmin {
  registeredCustomers: number;
  activeCustomers: number;
  inActiveCustomers: number;
  totalCurrentBalance: number;
  totalSpend: number;
  totalAmbassador: number;
}

interface Props {
  variables: QueryCustomersOverviewAdminArgs;
  children: (data: WithCustomersOverviewAdmin) => React.ReactElement | null;
}

export const CustomersOverviewAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    CustomersOverviewAdminQueryQuery,
    QueryCustomersOverviewAdminArgs
  >(customersOverviewAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const registeredCustomers = data?.customersOverviewAdmin?.registeredCustomers|| 0;
  const activeCustomers = data?.customersOverviewAdmin?.activeCustomers || 0;
  const inActiveCustomers = data?.customersOverviewAdmin?.inActiveCustomers || 0;
  const totalCurrentBalance = data?.customersOverviewAdmin?.totalCurrentBalance || 0;
  const totalSpend = data?.customersOverviewAdmin?.totalSpend || 0;
  const totalAmbassador = data?.customersOverviewAdmin?.totalAmbassador || 0;

  return children({
        registeredCustomers,
        activeCustomers,
        inActiveCustomers,
        totalCurrentBalance,
        totalSpend,
        totalAmbassador
  });
};